var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-list-wrap"},[_c('iframe',{staticClass:"screen-iframe",attrs:{"src":_vm.src,"frameborder":"no","scrolling":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }